import type { LucideIcon } from "lucide-react";
import { AlertCircle, ArrowUpRight, Inbox, LoaderCircle } from "lucide-react";
import type { ReactNode } from "react";

export function Button({ children, variant = "primary", icon: Icon, ...props }: React.ButtonHTMLAttributes<HTMLButtonElement> & { variant?: "primary" | "secondary" | "ghost" | "danger"; icon?: LucideIcon }) {
  return <button className={`button ${variant}`} {...props}>{Icon && <Icon size={17} />}{children}</button>;
}

export function MetricCard({ label, value, hint, icon: Icon, tone = "gold", delta }: { label: string; value: string | number; hint: string; icon: LucideIcon; tone?: string; delta?: string }) {
  return (
    <article className="metric-card">
      <div className={`metric-icon ${tone}`}><Icon size={19} /></div>
      <div className="metric-top"><span>{label}</span>{delta && <em><ArrowUpRight size={12} />{delta}</em>}</div>
      <strong className="metric-value">{value}</strong>
      <small>{hint}</small>
    </article>
  );
}

export function SectionCard({ title, subtitle, action, children, className = "" }: { title: string; subtitle?: string; action?: ReactNode; children: ReactNode; className?: string }) {
  return (
    <section className={`section-card ${className}`}>
      <header className="section-header"><div><h2>{title}</h2>{subtitle && <p>{subtitle}</p>}</div>{action}</header>
      {children}
    </section>
  );
}

export function StatusBadge({ status }: { status: string }) {
  const normalized = status.toLowerCase();
  return <span className={`status-badge ${normalized}`}><i />{status}</span>;
}

export function EmptyState({ title, description, action }: { title: string; description: string; action?: ReactNode }) {
  return <div className="empty-state"><span><Inbox size={24} /></span><h3>{title}</h3><p>{description}</p>{action}</div>;
}

export function LoadingState() {
  return <div className="loading-state"><LoaderCircle size={24} className="spin" /><span>Menyiapkan data...</span></div>;
}

export function ErrorState({ message, retry }: { message?: string; retry?: () => void }) {
  return <div className="error-state"><AlertCircle size={22} /><div><strong>Data belum dapat dimuat</strong><p>{message || "Periksa koneksi Worker dan coba kembali."}</p></div>{retry && <Button variant="secondary" onClick={retry}>Coba lagi</Button>}</div>;
}
